exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline[data-v-54fe231c]{padding-top:var(--inline-pad);overflow:hidden}.inline[data-v-54fe231c]:not(:last-child){padding-bottom:var(--inline-pad)}.inline>*[data-v-54fe231c]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:var(--inline-align);-ms-flex-align:var(--inline-align);align-items:var(--inline-align);-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin:calc(var(--inline-gap)/2*-1)}.inline>*>*[data-v-54fe231c]{margin:calc(var(--inline-gap)/2)}", ""]);

// exports
